import { gql } from '@apollo/client';

export const ALL_GRADES = gql`
  query AllGrades {
    grades {
      id
      value
    }
  }
`;
